import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select'; 
import { 
   Modal, Form, InputGroup,
} from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import { Button, ButtonGroup } from '@/shared/components/Button';
import { FaExclamationCircle } from 'react-icons/fa';
import { ShimmerContentBlock } from 'react-shimmer-effects';
import AwaitingCard from './AwaitingCard';
import Loading from '../../../../../shared/components/Loading';
import { GlobalContext } from '../../../../../context/GlobalContext';
import ProgressBar from '../../../Loader';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';
import { AuthContext } from '../../../../../context/AuthContext';

const Awaiting = ({ agentId }) => {
  const { apiGlobal } = useContext(GlobalContext);
  const [bookingData, setBookingData] = useState([]);
  const [filteredBookingData, setFilteredBookingData] = useState([]);
  const [paxDetailsHandler, setPaxDetailsHandler] = useState([]);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [tripOption, setTripOption] = useState([]);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const { countryId } = useContext(AuthContext);

      // Search filter states
      const [searchTripName, setSearchTripName] = useState('');
      const [searchStartDate, setSearchStartDate] = useState('');
      const [searchEndDate, setSearchEndDate] = useState('');

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 2;

  const fetchBookingData = async () => {
    const formData = new FormData();
    formData.append('agent_id', agentId);
    formData.append('country_id', countryId);
    try {
      const url = await fetch(`${apiGlobal}/agent/booking_awaiting_list.php`, {
        method: 'POST',
        body: formData,
      });
      const response = await url.json();
      if (response?.status && response?.message) {
        setBookingData(response?.data);
        setFilteredBookingData(response?.data); // Initial setting of filtered data
        const tripOptions = response?.data?.map(trip => ({
          value: trip?.id,
          label: `${trip?.name } (${trip?.trip_uin})`, 
        }));
        setTripOption(tripOptions);
        setIsLoading(false);
      } else {
        setBookingData([]);
        setIsLoading(true);
      }
    } catch (error) {
      console.error(error);
      setIsLoading(true);
    }
  };

  useEffect(() => {
    fetchBookingData();
  }, [agentId, refresh, sideBarRefresh?.agentBookingRefresh]);

  const filterBookingHandler = (selectedOption) => {
    setSelectedTrip(selectedOption); // Update selected trip

    if (!selectedOption) {
      setFilteredBookingData(bookingData); // Reset filter when no trip is selected
      setCurrentPage(1); // Reset to the first page when filtering
      return;
    }

    // Filter booking data based on selected trip ID
    const filteredData = bookingData.filter(trip => trip?.id === selectedOption?.value);
    setFilteredBookingData(filteredData);
    setCurrentPage(1); // Reset to the first page when filtering
  };

  // Pagination logic
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredBookingData.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages
  const totalPages = Math.ceil(filteredBookingData.length / itemsPerPage);
   // Filter Data Based on Date Range
   useEffect(() => {
    let filteredData = [...bookingData];

    if (searchStartDate) {
      filteredData = filteredData.filter((trip) => {
        const tripStartDate = new Date(trip?.start_date);
        return tripStartDate >= new Date(searchStartDate);
      });
    }

    if (searchEndDate) {
      filteredData = filteredData.filter((trip) => {
        const tripEndDate = new Date(trip?.end_date);
        return tripEndDate <= new Date(searchEndDate);
      });
    }

    setFilteredBookingData(filteredData);
  }, [searchStartDate, searchEndDate, bookingData]);

   // use Effect to add keyframes for the pulse animation
   useEffect(() => {
    // Add keyframes via JavaScript when component mounts
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.2); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }, []);


  if (isLoading) {
    return (
      <div>
        <ProgressBar />
      </div>
    );
  }

  return (
    <div>
      <div
        className="mb-4"
        style={{
          padding: '15px',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '10px', // Add gap between the input fields
          alignItems: 'center', // Vertically align input fields and button
          flexWrap: 'wrap', // Make sure the filters stay in a single line
        }}
      >
        {/* <h5
          className="mb-2"
          style={{
            color: '#495057',
            alignSelf: 'center',
            marginRight: '20px',
            fontWeight: '600',
          }}
        >
          Filter Trips
        </h5> */}
 
        {/* <InputGroup className="mb-2" style={{ maxWidth: '200px' }}>
          <Form.Control
            type="text"
            placeholder="Search by Trip Name"
            value={searchTripName}
            onChange={e => setSearchTripName(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup> */}
        <Select
          name="tripName"
          className="react-select w-25 mb-4 mt-3"
          classNamePrefix="react-select"
          options={tripOption}
          isClearable
          value={selectedTrip}
          placeholder="Select a trip"
          onChange={filterBookingHandler}
        />
        <ButtonGroup icons dir="ltr" className="mt-2">
          <Button
            variant="outline-secondary"
            className=""
            title="Refresh"
            size="sm"
            onClick={() => setRefresh(prev => !prev)}
          >
            <span className="lnr lnr-sync text-primary" />
          </Button>
        </ButtonGroup>
        {/* Search Filters */}
 
        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="Start Date"
            value={searchStartDate}
            onChange={e => setSearchStartDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>
 
        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="End Date"
            value={searchEndDate}
            onChange={e => setSearchEndDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>
 
        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '10px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => {
            setSearchTripName('');
            setSearchStartDate('');
            setSearchEndDate('');
          }}
        >
          Clear Filters
        </Button>
        {/* <Button
          variant="outline-primary"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => setShowAddModal(true)}
        >
          Add Trip
        </Button> */}
      </div>
      {/* <Select
        name="tripName"
        className="react-select w-25 mb-4"
        classNamePrefix="react-select"
        options={bookingData.map(trip => ({
          value: trip?.id,
          label: `${trip?.name} (${trip?.trip_uin})`,
        }))}
        isClearable
        value={selectedTrip}
        placeholder="Select a trip"
        onChange={filterBookingHandler}
      /> */}

      <div>
        {currentItems.length > 0 ? (
          currentItems.map(booking => (
            <AwaitingCard 
              key={booking?.id}
              bookingData={booking}
              setRefresh={setRefresh}
              paxDetailsHandler={paxDetailsHandler}
              setPaxDetailsHandler={setPaxDetailsHandler}
            />
          ))
        ) : (
          <div style={{
            textAlign: 'center',
            padding: '50px',
            backgroundColor: '#f8d7da',
            borderRadius: '8px',
            marginTop: '20px',
            color: '#721c24',
            fontSize: '16px',
            }}
          >
            <div
              style={{
              fontSize: '48px',
              marginBottom: '20px',
              color: '#e63946',
              animation: 'pulse 1.5s infinite ease-in-out',
              display: 'inline-block',
              }}
            >
              <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
            </div>
            <p>No Awaiting booking available</p>
          </div>
        )}
      </div>

      {/* Pagination Controls */}
      <div style={{
        float: 'right',
        bottom: '20px', 
        right: '20px', 
        zIndex: 999, 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
      }}
      >
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
    </div>
  );
};

Awaiting.propTypes = {
  agentId: PropTypes.string.isRequired,
};

export default Awaiting;
